import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { get } from '../../services/http'
import { initialBranding } from '../intialState/branding';
import { SliceStatus } from '../../interfaces/Redux';


export interface recoveryData 
{
    recoveryPhone: any, 
    recoveryEmailAddress: any
}

export interface recovery 
{
    recovery: recoveryData
    status: SliceStatus
    error?: string | undefined
}

const initialState: recovery = {
    recovery: {
        recoveryPhone:null,
        recoveryEmailAddress:null
    },
    status: SliceStatus.idle,
    error: '',
}

export const recoverySlice = createSlice({
  name: 'recovery',
  initialState,
  reducers: {
      resetRecovery: () => initialState
  },
  extraReducers(builder) {
    builder
      .addCase(fetchRecovery.pending, (state, action) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchRecovery.fulfilled, (state, action) => {
        if(action.payload) {
          state.status = SliceStatus.succeeded;
          state.recovery = action.payload;
          state.error = undefined;
        }
      })
      .addCase(fetchRecovery.rejected, (state, action) => {
        state.status = SliceStatus.failed
        state.recovery = initialState.recovery;
        state.error = action.error.message
      })
  }
})

export const fetchRecovery = createAsyncThunk('recovery/fetchRecovery', async () => {

    const { data } = await  get(`api/recovery`)
      .catch((response) => {
        throw new Error(response.message);
      });

    if (data) {
        return data
    }

    return initialBranding
})

export const { resetRecovery } = recoverySlice.actions;

export default recoverySlice.reducer



